"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("../index.scss");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const InputShareEdit_1 = __importDefault(require("@Components/Fields/InputShareEdit"));
const removers_1 = require("@App/helpers/work-entities/removers");
const permission_1 = require("@App/helpers/permission");
const contexts_1 = require("@App/contexts");
class OriginPublisherCardEditable extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "publisherShare", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.data.publisherShare ? this.props.data.publisherShare : 0
        });
        Object.defineProperty(this, "sharesInvalid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getShares", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (shares) => {
                this.publisherShare = +shares;
                this.setOPToDraft();
                if (this.props.onShareChange) {
                    this.props.onShareChange();
                }
            }
        });
        Object.defineProperty(this, "setOPToDraft", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const workDraftFromLocal = this.context.workStore.workDraftLocal;
                const editingOP = this.props.data;
                const editingOPId = editingOP.localId;
                if (!workDraftFromLocal || !editingOP) {
                    return;
                }
                const originalPublishers = workDraftFromLocal.originalPublishers;
                const indexOfOP = originalPublishers.map((op) => op.localId).indexOf(editingOPId);
                const updatedOP = {
                    id: editingOP.id,
                    localId: editingOPId,
                    ipId: editingOP.ipId,
                    amend: true,
                    publisherName: editingOP.publisherName,
                    ipiNumber: editingOP.ipiNumber,
                    publisherShare: this.publisherShare,
                    administratorPublishers: editingOP.administratorPublishers,
                    writers: editingOP.writers,
                    hfaPublisherNumber: editingOP.hfaPublisherNumber,
                };
                const updatedOPArray = (0, removers_1.setItemToArrayByIndex)(originalPublishers, +indexOfOP, updatedOP);
                const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { originalPublishers: updatedOPArray });
                this.context.workStore.setWorkDraftToLocal(updatedWorkDraft);
            }
        });
        Object.defineProperty(this, "stepValidator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.sharesInvalid = this.props.data.publisherShare ? this.props.data.publisherShare <= 0 : true;
                this.context.workStore.setWizardStepValidation(!this.sharesInvalid);
            }
        });
        (0, mobx_1.makeObservable)(this, {
            publisherShare: mobx_1.observable,
            sharesInvalid: mobx_1.observable,
            getShares: mobx_1.action,
            setOPToDraft: mobx_1.action,
        });
    }
    componentDidUpdate() {
        this.stepValidator();
    }
    componentDidMount() {
        this.stepValidator();
    }
    render() {
        const { data, shareError } = this.props;
        const classNames = ['original-publisher-card'].join(' ');
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: 'head' },
                react_1.default.createElement("p", { className: 'bold' }, data.publisherName)),
            react_1.default.createElement("div", { className: 'content' },
                react_1.default.createElement("p", { className: 'small' },
                    "IPI: ",
                    react_1.default.createElement("strong", null, data.ipiNumber)),
                !data.administratorPublishers.length && (0, permission_1.canAmend)(data.amend) ? (react_1.default.createElement(InputShareEdit_1.default, { onChange: this.getShares, value: this.publisherShare, shareError: shareError, label: 'Publisher share:' })) : null)));
    }
}
exports.default = (0, mobx_react_1.observer)(OriginPublisherCardEditable);
OriginPublisherCardEditable.contextType = contexts_1.StoresContext;
